(function () {
  "use strict";
  var LOC = ((window.Shopify && window.Shopify.locale) || "de").slice(0, 2);
  var ROOT_SEL = ".pplr-popup, .pplr-modal-box, .pplr_form, #pplr_html";

  /* ---------- 1) Feldnamen ---------- */
  var LABELS = {
    "INITIALIEN":    { en:"INITIALS", es:"INICIALES", fr:"INITIALES", it:"INIZIALI", nl:"INITIALEN", pl:"INICJAŁY", sv:"INITIALER" },
    "NUMMER":        { en:"NUMBER", es:"NÚMERO", fr:"NUMÉRO", it:"NUMERO", nl:"NUMMER", pl:"NUMER", sv:"NUMMER" },
    "LÄNDERFLAGGEN": { en:"COUNTRY FLAGS", es:"BANDERAS DE PAÍSES", fr:"DRAPEAUX DES PAYS", it:"BANDIERE DEI PAESI", nl:"LANDENVLAGGEN", pl:"FLAGI PAŃSTW", sv:"LANDSFLAGGOR" }
  };

  /* ---------- 2) Zeichenzaehler ---------- */
  var COUNTER = {
    en:"characters left", es:"caracteres restantes", fr:"caractères restants",
    it:"caratteri rimasti", nl:"tekens over", pl:"pozostało znaków", sv:"tecken kvar",
    de:"Zeichen frei"
  };

  /* 22.10. (Nutzerbefund, Freigabe): Zepto zeigt im Zaehler die VERBLEIBENDEN Zeichen (.ct), das Wort dazu (.lt) blendet
     Zeptos CSS aus -> leeres Feld "2 / 2", volles "0 / 2". Wir zeigen die EINGEGEBENEN Zeichen in eigenem Span .bs-ct,
     Zeptos .ct bleibt unveraendert im DOM (nur ausgeblendet). */
  var SELECT_FLAG = {
    de:"Land wählen", en:"Select a country", es:"Elige un país", fr:"Choisir un pays",
    it:"Scegli un paese", nl:"Kies een land", pl:"Wybierz kraj", sv:"Välj land"
  };

  /* ---------- 3) Suchfeld ---------- */
  var SEARCH_PH = {
    de:"Land suchen …", en:"Search country …", es:"Buscar país …", fr:"Rechercher un pays …",
    it:"Cerca un paese …", nl:"Land zoeken …", pl:"Szukaj kraju …", sv:"Sök land …"
  };
  var SEARCH_EMPTY = {
    de:"Kein Land gefunden", en:"No country found", es:"Ningún país encontrado", fr:"Aucun pays trouvé",
    it:"Nessun paese trovato", nl:"Geen land gevonden", pl:"Nie znaleziono kraju", sv:"Inget land hittades"
  };

  /* ---------- 4) Laendernamen ---------- */
  /* Zepto-Wert -> ISO-Regionscode; Namen kommen aus Intl.DisplayNames der jeweiligen Sprache. */
  var ISO = {
    "Aegypten":"EG","Albanien":"AL","Algerien":"DZ","Argentienien":"AR","Armenien":"AM","Belgien":"BE",
    "Bosnien":"BA","Brasilien":"BR","Bulgarien":"BG","Daenemark":"DK","Deutschland":"DE","Finnland":"FI",
    "Frankreich":"FR","Ghana":"GH","Griechenland":"GR","Guinea":"GN","Indien":"IN","Irak":"IQ","Iran":"IR",
    "Irland":"IE","Italien":"IT","Japan":"JP","Kamerun":"CM","Kanada":"CA","Kolumbien":"CO","Kosovo":"XK",
    "Kroatien":"HR","Libanon":"LB","Luxemburg":"LU","Mali":"ML","Marokko":"MA","Mazedonien":"MK","Mexico":"MX",
    "Montenegro":"ME","Niederlande":"NL","Nigeria":"NG","Norwegen":"NO","Oesterreich":"AT","Pakistan":"PK",
    "Palestina":"PS","Polen":"PL","Portugal":"PT","Rumaenien":"RO","Russland":"RU","Schweden":"SE","Schweiz":"CH",
    "Senegal":"SN","Serbien":"RS","Slowakei":"SK","Slowenien":"SI","Spanien":"ES","Suedkorea":"KR","Syrien":"SY",
    "Tschechien":"CZ","Tunesien":"TN","Ukraine":"UA","Ungarn":"HU","Uruguay":"UY","Usa":"US","Zypern":"CY",
    /* BE-STABLE (2026-10-09) Audit Nr. 20: Zepto schreibt diese Laender so (Lese-Test 09.10.); die alten
       Schreibweisen oben ("Argentienien", "Mexico", "Palestina", "Usa") trafen nie und bleiben nur als Rueckfall. */
    "Argentinien":"AR","Mexiko":"MX"
  };
  /* Ohne eigenen Regionscode oder mit unpassendem Amtsnamen: von Hand. */
  var FEST = {
    "Amazigh":     { en:"Amazigh", es:"Amazigh", fr:"Amazigh", it:"Amazigh", nl:"Amazigh", pl:"Amazigh", sv:"Amazigh" },
    "England":     { en:"England", es:"Inglaterra", fr:"Angleterre", it:"Inghilterra", nl:"Engeland", pl:"Anglia", sv:"England" },
    "Schottland":  { en:"Scotland", es:"Escocia", fr:"Écosse", it:"Scozia", nl:"Schotland", pl:"Szkocja", sv:"Skottland" },
    "Kongo":       { en:"Congo", es:"Congo", fr:"Congo", it:"Congo", nl:"Congo", pl:"Kongo", sv:"Kongo" },
    "Kurdistan":   { en:"Kurdistan", es:"Kurdistán", fr:"Kurdistan", it:"Kurdistan", nl:"Koerdistan", pl:"Kurdystan", sv:"Kurdistan" },
    "Elfenbeinkueste": { en:"Ivory Coast", es:"Costa de Marfil", fr:"Côte d’Ivoire", it:"Costa d’Avorio", nl:"Ivoorkust", pl:"Wybrzeże Kości Słoniowej", sv:"Elfenbenskusten" },
    "Tuerkei":     { en:"Turkey", es:"Turquía", fr:"Turquie", it:"Turchia", nl:"Turkije", pl:"Turcja", sv:"Turkiet" },
    "Usa":         { en:"USA", es:"Estados Unidos", fr:"États-Unis", it:"Stati Uniti", nl:"Verenigde Staten", pl:"Stany Zjednoczone", sv:"USA" },
    /* BE-STABLE (2026-10-09) Audit Nr. 20: Zepto-Werte "USA" und "Palästina". Palaestina von Hand wie im deutschen
       Original (der Amtsname aus Intl waere "Palestinian Territories" bzw. "Territoires palestiniens"). */
    "USA":         { en:"USA", es:"Estados Unidos", fr:"États-Unis", it:"Stati Uniti", nl:"Verenigde Staten", pl:"Stany Zjednoczone", sv:"USA" },
    "Palästina":   { en:"Palestine", es:"Palestina", fr:"Palestine", it:"Palestina", nl:"Palestina", pl:"Palestyna", sv:"Palestina" }
  };

  var displayNames = null;
  try { if (window.Intl && Intl.DisplayNames) displayNames = new Intl.DisplayNames([LOC], { type: "region" }); } catch (e) { displayNames = null; }

  var cache = {};
  function land(orig) {
    if (!orig) return null;
    if (cache.hasOwnProperty(orig)) return cache[orig];
    var out = null;
    if (FEST[orig] && FEST[orig][LOC]) out = FEST[orig][LOC];
    else if (ISO[orig] && displayNames) {
      try { var v = displayNames.of(ISO[orig]); if (v && v !== ISO[orig]) out = v; } catch (e) {}
    }
    if (out === orig) out = null;
    cache[orig] = out;
    return out;
  }

  /* ---------- Helfer ---------- */
  function ersterTextknoten(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n;
    }
    return null;
  }
  function setzeText(node, neu) {
    if (node && node.textContent.trim() !== neu) node.textContent = neu;
  }
  /* Ersetzt NUR die Beschriftung, nie ein Bild. Zeptos Eintraege sehen so aus:
     .img_dropdown > span.ppsrc(IMG) + span.ppdata(Text)  und  .swtooltip > IMG + SPAN(Text).
     Ein plattes textContent auf dem Container loescht die Flagge (live belegt 26.08.). */
  function setzeBeschriftung(el, neu, tiefe) {
    if (!el || (tiefe || 0) > 3) return;
    if (el.childElementCount === 0) { setzeText(el, neu); return; }
    var tn = ersterTextknoten(el);
    if (tn) { setzeText(tn, neu); return; }
    var kand = el.querySelector(".ppdata") || el.lastElementChild;
    if (kand) setzeBeschriftung(kand, neu, (tiefe || 0) + 1);
  }
  function normalisiere(s) {
    return String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/ß/g, "ss").replace(/[^a-z0-9]/g, "");
  }

  /* Audit Nr. 19: deutsche Umschrift (ä -> ae, ö -> oe, ü -> ue) vor dem Normalisieren */
  function umschrift(s) {
    return normalisiere(String(s || "").toLowerCase().replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue"));
  }
  /* Audit Nr. 19: Zeptos Umschrift zurueck in Umlaute (nur als zusaetzlicher Suchname, nie zur Anzeige) */
  function mitUmlauten(s) {
    return String(s || "").replace(/Ae/g, "Ä").replace(/Oe/g, "Ö").replace(/Ue/g, "Ü")
      .replace(/ae/g, "ä").replace(/oe/g, "ö").replace(/ue/g, "ü");
  }

  /* ---------- --Select-- (22.10.), auch fuer Deutsch ---------- */
  function waehleText() {
    var anz = document.querySelectorAll(".pplr-selecter-selected");
    for (var i = 0; i < anz.length; i++) {
      var w = anz[i].closest(".pplr-wrapper");
      var h = w && w.querySelector('input.pplr_imgg[name="properties[LÄNDERFLAGGEN]"]');
      if (!h || w.querySelector(".pplr-swatch-element.selected[data-val]")) continue;
      if (/^\s*--\s*select\s*--\s*$/i.test(anz[i].textContent || "")) setzeBeschriftung(anz[i], SELECT_FLAG[LOC] || SELECT_FLAG.de, 0);
    }
  }

  /* ---------- Zaehler (22.10.) ---------- */
  function zaehler() {
    var cs = document.querySelectorAll(".pplr-character-count");
    for (var i = 0; i < cs.length; i++) {
      var c = cs[i], w = c.closest(".pplr-wrapper");
      var inp = w && w.querySelector("input[type=text][maxlength], textarea[maxlength]");
      if (!inp) continue;
      var own = c.querySelector(".bs-ct");
      if (!own) { own = document.createElement("span"); own.className = "bs-ct"; c.insertBefore(own, c.firstChild); }
      setzeText(own, String(Array.from(inp.value || "").length));
      /* Nur wenn Zepto das Wort "verbleibend" (.lt) ausblendet (Handy-Layout, "x / max"). Am Computer zeigt Zepto
         "2 Zeichen frei" - dort stimmt Zeptos Restzahl und bleibt stehen. */
      var lt = c.querySelector(".lt");
      var an = !(lt && getComputedStyle(lt).display !== "none");
      if (c.classList.contains("bs-ct-an") !== an) c.classList.toggle("bs-ct-an", an);
    }
  }

  /* ---------- Uebersetzen ---------- */
  function uebersetze() {
    var i;
    waehleText();
    /* Der Zaehler kommt bei Zepto IMMER englisch - auch im deutschen Shop. Darum vor dem de-Ausstieg. */
    if (COUNTER[LOC]) {
      var ltAlle = document.querySelectorAll(".pplr-character-count .lt");
      for (i = 0; i < ltAlle.length; i++) setzeText(ltAlle[i], COUNTER[LOC]);
    }
    if (LOC === "de") return;
    var labels = document.querySelectorAll(".pplr-wrapper .pplrlabel");
    for (i = 0; i < labels.length; i++) {
      var tn = ersterTextknoten(labels[i]);
      if (!tn) continue;
      var t = tn.textContent.trim();
      if (LABELS[t] && LABELS[t][LOC]) setzeText(tn, LABELS[t][LOC]);
    }
    var swatches = document.querySelectorAll(".pplr-wrapper .pplr-swatch-element[data-val]");
    for (i = 0; i < swatches.length; i++) {
      var orig = swatches[i].getAttribute("data-val");
      var neu = land(orig);
      if (!neu) continue;
      var dd = swatches[i].querySelector(".img_dropdown");
      var tt = swatches[i].querySelector(".swtooltip");
      if (dd) setzeBeschriftung(dd, neu, 0);
      if (tt) setzeBeschriftung(tt, neu, 0);
    }
    var anzeigen = document.querySelectorAll(".pplr-selecter-selected");
    for (i = 0; i < anzeigen.length; i++) {
      var wrapper = anzeigen[i].closest(".pplr-wrapper");
      if (!wrapper) continue;
      var hidden = wrapper.querySelector("input.pplr_imgg");
      var aktiv = wrapper.querySelector(".pplr-swatch-element.selected[data-val]");
      var origWert = aktiv ? aktiv.getAttribute("data-val") : (hidden ? hidden.value : null);
      var neuWert = land(origWert);
      if (!neuWert) continue;
      setzeBeschriftung(anzeigen[i], neuWert, 0);
      if (hidden && hidden.value !== neuWert && normalisiere(hidden.value) === normalisiere(origWert)) hidden.value = neuWert;
    }
  }

  /* ---------- Suchfeld ---------- */
  function baueSuche(wrapper) {
    var liste = wrapper.querySelector(".img_thumb_dropdown");
    if (!liste || wrapper.querySelector(".bs-flag-search")) return;
    var swatches = liste.querySelectorAll(".pplr-swatch-element[data-val]");
    if (swatches.length < 12) return;

    var box = document.createElement("div");
    box.className = "bs-flag-search";
    var feld = document.createElement("input");
    feld.type = "text";
    feld.className = "bs-flag-search__input";
    feld.setAttribute("autocomplete", "off");
    feld.setAttribute("aria-label", SEARCH_PH[LOC] || SEARCH_PH.de);
    feld.placeholder = SEARCH_PH[LOC] || SEARCH_PH.de;
    var leer = document.createElement("div");
    leer.className = "bs-flag-search__empty";
    leer.textContent = SEARCH_EMPTY[LOC] || SEARCH_EMPTY.de;
    leer.style.display = "none";
    box.appendChild(feld);
    box.appendChild(leer);
    /* WICHTIG: Zepto findet die Flaggenliste ueber nextElementSibling der Anzeige.
       Ein Element ZWISCHEN Anzeige und Liste blockiert das Aufklappen (live belegt 26.08.).
       Darum haengt das Suchfeld IN die Liste, als erstes Kind - es traegt keine
       .pplr-swatch-element-Klasse und faellt aus Zeptos Selektoren heraus. */
    liste.insertBefore(box, liste.firstChild);

    /* Klicks/Tasten im Suchfeld duerfen das Dropdown nicht schliessen.
       Zeptos Schliess-Handler haengt am DOCUMENT und feuert auf "mouseup" (26.08. live gemessen:
       die Liste ging zwischen mouseup-Capture und mouseup-Bubble zu). mouseup MUSS also mit in die
       Liste - click und mousedown allein reichen nicht. Zeiger- und Touch-Varianten vorsorglich dazu. */
    ["click", "dblclick", "mousedown", "mouseup", "pointerdown", "pointerup",
     "touchstart", "touchend", "keydown", "keyup"].forEach(function (ev) {
      box.addEventListener(ev, function (e) { e.stopPropagation(); }, false);
    });

    /* BE-STABLE (2026-10-09) Audit Nr. 19: Umlaute gleichsetzen. Zepto speichert deutsche Namen in Umschrift
       (Tuerkei, Oesterreich, Aegypten). Jeder Name wird in zwei Schreibweisen verglichen - Akzente entfernt
       (ue -> u bzw. ü -> u) und deutsche Umschrift (ü -> ue) - und zusaetzlich mit Umlauten (Tuerkei -> Türkei).
       So finden "türk", "turk" und "tuerk" die Tuerkei. Die Anzeige bleibt unveraendert. */
    function filtern() {
      var qa = normalisiere(feld.value), qb = umschrift(feld.value);
      var treffer = 0;
      for (var i = 0; i < swatches.length; i++) {
        var orig = swatches[i].getAttribute("data-val") || "";
        var namen = [orig, land(orig) || "", mitUmlauten(orig)];
        var passt = !qa;
        for (var k = 0; !passt && k < namen.length; k++) {
          if (!namen[k]) continue;
          passt = normalisiere(namen[k]).indexOf(qa) !== -1 || umschrift(namen[k]).indexOf(qb) !== -1;
        }
        swatches[i].style.display = passt ? "" : "none";
        if (passt) treffer++;
      }
      leer.style.display = treffer ? "none" : "";
    }
    feld.addEventListener("input", filtern);
    feld.addEventListener("search", filtern);

    /* Beim Zuklappen Filter zuruecksetzen; sichtbar/unsichtbar regelt die Liste selbst. */
    function sync() {
      var offen = !!(liste.offsetWidth || liste.offsetHeight);
      if (!offen && feld.value) { feld.value = ""; filtern(); }
    }
    new MutationObserver(sync).observe(liste, { attributes: true, attributeFilter: ["style", "class"] });
  }

  function suchfelder() {
    var wraps = document.querySelectorAll(".pplr-wrapper");
    for (var i = 0; i < wraps.length; i++) baueSuche(wraps[i]);
  }

  /* ---------- Stil ---------- */
  function stil() {
    if (document.getElementById("bs-flag-search-style")) return;
    var s = document.createElement("style");
    s.id = "bs-flag-search-style";
    s.textContent =
      ".bs-flag-search{position:sticky;top:0;z-index:3;background:#fff;padding:6px 0 4px;margin:0}" +
      /* !important noetig: Zepto setzt ".pplr-swatch-main input{display:none}" - versteckt sonst auch unser Feld (live belegt 26.08.). */
      ".bs-flag-search__input{display:block !important;visibility:visible !important;height:auto !important;" +
      "width:100%;box-sizing:border-box;padding:8px 10px;font-size:14px;line-height:1.3;" +
      "border:1px solid rgba(0,0,0,.25);border-radius:4px;background:#fff;color:#111;outline:none}" +
      ".bs-flag-search__input:focus{border-color:#111}" +
      ".bs-flag-search__empty{padding:8px 2px;font-size:13px;opacity:.65}" +
      /* 22.10. Zaehler: eigener Wert statt Zeptos Restzahl */
      ".pplr-character-count.bs-ct-an .ct{display:none !important}" +
      ".pplr-character-count .bs-ct{display:none}" +
      ".pplr-character-count.bs-ct-an .bs-ct{display:block}";
    (document.head || document.documentElement).appendChild(s);
  }

  /* ---------- Audit Nr. 7: deutscher Flaggenname fuer die Produktion ---------- */
  /* Die sichtbare Eigenschaft LÄNDERFLAGGEN bleibt in der Kundensprache (Entscheid 26.08.). Zusaetzlich liegt in
     Zeptos Formular ein verstecktes Feld _LÄNDERFLAGGEN_DE mit Zeptos deutschem Originalwert (Unterstrich: im
     Warenkorb und in der Kasse unsichtbar, in der Bestellung im Shopify-Admin sichtbar). Quelle: data-val der
     gewaehlten Flagge, sonst Zeptos Vorbelegung (defaultValue des versteckten Felds). Ob Zepto das Feld mitsendet,
     haengt davon ab, ob Zepto das ganze Formular uebertraegt - im Test vom 09.10. zu pruefen. */
  var DE_FELD = "properties[_LÄNDERFLAGGEN_DE]";
  function deutscheFlagge() {
    var hiddens = document.querySelectorAll('input.pplr_imgg[name="properties[LÄNDERFLAGGEN]"]');
    for (var i = 0; i < hiddens.length; i++) {
      var h = hiddens[i], form = h.form || h.closest("form"), wrap = h.closest(".pplr-wrapper");
      if (!form) continue;
      var aktiv = wrap ? wrap.querySelector(".pplr-swatch-element.selected[data-val]") : null;
      var wert = aktiv ? aktiv.getAttribute("data-val") : h.defaultValue;
      if (!wert) continue;
      var feld = null;
      for (var k = 0; k < form.elements.length; k++) {
        if (form.elements[k].name === DE_FELD) { feld = form.elements[k]; break; }
      }
      if (!feld) {
        feld = document.createElement("input");
        feld.type = "hidden";
        feld.name = DE_FELD;
        form.appendChild(feld);
      }
      if (feld.value !== wert) feld.value = wert;
    }
  }
  /* Direkt vor Zeptos "In den Warenkorb" noch einmal abgleichen (Capture laeuft vor Zeptos Klick-Handler). */
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest(".p_a_t_c")) { try { deutscheFlagge(); } catch (err) {} }
  }, true);

  /* ---------- Lauf ---------- */
  var geplant = false;
  function lauf() {
    if (geplant) return;
    geplant = true;
    setTimeout(function () {
      geplant = false;
      try { stil(); deutscheFlagge(); uebersetze(); suchfelder(); zaehler(); } catch (e) {}
    }, 60);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", lauf);
  else lauf();
  document.addEventListener("click", function () { setTimeout(lauf, 120); setTimeout(lauf, 500); }, true);
  new MutationObserver(lauf).observe(document.documentElement, { childList: true, subtree: true });
  /* 22.10.: Zaehler sofort bei jeder Eingabe (auch iOS-Vorschlagsleiste/Einfuegen) */
  document.addEventListener("input", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest(".pplr-wrapper")) { try { zaehler(); } catch (err) {} }
  }, true);
  window.addEventListener("resize", function () { try { zaehler(); } catch (err) {} });
})();
